"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialCreationMethod = void 0;
var MaterialCreationMethod;
(function (MaterialCreationMethod) {
    MaterialCreationMethod["FromCourseBuilder"] = "fromCourseBuilder";
    MaterialCreationMethod["FromScratch"] = "fromScratch";
    MaterialCreationMethod["FromTemplate"] = "fromTemplate";
    MaterialCreationMethod["FromPresentation"] = "fromPresentation";
})(MaterialCreationMethod || (exports.MaterialCreationMethod = MaterialCreationMethod = {}));
